import {Injectable} from '@angular/core';
import {ActionModel} from '../models/action.model';

@Injectable({
    providedIn: 'root'
})
export class CleanUpDocumentBeanService {

    constructor() {
    }

    cleanDoc(obj) {
        delete obj.signLater;
        // TODO check if this is correct
        if (obj.deposit && (!obj.deposit.amount || obj.deposit.amount === 0)) {
            obj.deposit = null;
        }
        for (const k in obj) {
            if (k === 'meta' || k === '$loki' || k === 'signLater' || k === 'isChecked') {
                delete obj[k];
            } else if (typeof obj[k] === 'object' && !!obj[k]) {
                this.cleanDoc(obj[k]);
            }
        }
    }

    cleanExtraFieldActions(action: ActionModel) {
        delete action.actorName;
        delete action.creatorName;
        delete action.priorityDesc;
        delete action.typeDesc;
        if (action.customerDTO && action.customerDTO.cod) {
            delete action.customerDTO;
        }
        if (action.contactDTO && action.contactDTO.id) {
            delete action.contactDTO;
        }
    }
}
